// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5d-1";
export var standaloneTable = "_5d-0";